module.exports = __webpack_public_path__ + "assets/app/img/ie-inspect.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/images/ie-inspect.png
// module id = oK86
// module chunks = 1